alert('CUSTOM JS IS RUNNING');
document.addEventListener('DOMContentLoaded', function() {

  // Existing custom variant behavior
  $('.customm_product .disabled.customhide').prop("disabled", true);

  const customHide = document.getElementsByClassName('customhide')[0];
  if (customHide) {
    customHide.style.display = 'none';
  }

  $('.customm_product .disabled.customhide').prop("disabled", true);
  $('.customm_product .disabled.customhide').hide();


// DEFAULT COLLECTION FILTER
if (
  window.location.pathname.startsWith('/collections/') &&
  window.location.search === ''
) {
  window.location.replace(
    window.location.pathname + '?filter.v.availability=1'
  );
  return;
}

  // Existing Quick Add behavior
  $('.quick-add__submit').click(function() {
    setTimeout(function() {
      const customHide = document.querySelector('.customhide');

      if (customHide) {
        customHide.style.display = 'none';
      }
    }, 1000);
  });

});